export default {
  isModified: false,
  forceRefreshOnSave: null,
  editTMP: null,
  enterpriseColor: '#689E99',
  btnBackgroundColor: '',
  btnTextColor: '',
  foodDrinkTextColor: '',
  foodDrinkBGColor: '',
  enterpriseID: null,
  enterpriseName: '',
  userName: '',
  BGColor: '#56A099',
  BGColorSecundary: '#CCCCCC',
  BGColorContent: '#FFFFFF',
  Color: '#FFFFFF',
  ColorSecundary: '#495057',
  ColorContent: '#495057',
  GlobalFont: 'Roboto',
  Font: 'Roboto',
  FontSecundary: 'Roboto',
  FontContent: 'Roboto',
  FontSize: 20,
  FontSizeSecundary: 16,
  FontSizeContent: 14,
  TextFormat: null,
  TextFormatSecundary: null,
  Carousel: [],
  Logo: 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png',
  TimeZone: 'Europe/London',
  Languages: ['es'],
  DefaultLocale: 'es',
  locale: 'es',
  withGradient: true,
  withGradientSubmenu: true,
  withLine: false,
  menus: [],
  contents: [],
  collapseContent: false,
  mainFormWidth: null,
  expandMenuID: null,
  isTotemAccessibility: false,
  totemMeteoID: null,
  totemMenuSelected: null,
  allergenFilters: false,
  selectedAllergenFilters: [],
  showDishesImage: false,
  showDishesAllergens: false,
  foodIconRight: false,
  dfileWorkspace: null,

  saving: false,
  authType: 'none',
  authData: null,
  hideSettings: true,
  activeMenuID: null,

  isMenuLeft: false,

  dtouchDeeplTranslateActive: true,
  dtouchDeeplTranslateLocale: 'es',

  dtouchWorkspace: null, // compatibility with contentManager
  dtouchIsTouchPublic: false,

  dtouchDishOrder: null,

  totemLastClickTime: null,
  totemBackDomain: null,
  totemDomain: null,
  totemActiveMenu: null,
  totemActiveMenuItem: null,
  totemLMD: null,
  totemItemImage: null,
  totemItemImageTranslate: null,
  totemItemPDF: null,
  totemItemBookingWorkspaceID: null,
  totemItemBookingCategoryFilter: null,

  bookingUpdateAvailability_resource: null,

  cacheFormData: false,
}
